import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../components/forms/Buttons/Button';
import { getFile } from '../../../services/file/fileService';
import useSnackbar from '../../../utils/hooks/useSnackbar';
import { getExportExamCenterStats } from '../../../services/catalog/districts';

const INTERVAL_TIME = 1000;
const REQUEST_LIMIT = 60;

const ExportExamCenterStats = ({ params }) => {
  const [t] = useTranslation();
  const { addSnackbar } = useSnackbar();

  const [loadingFile, setLoadingFile] = useState(false);

  const handle = () => {
    setLoadingFile(true);

    let request_counter = 0;

    getExportExamCenterStats({ params }).then((res) => {
      const intervalId = setInterval(() => {
        if (request_counter >= REQUEST_LIMIT) {
          clearInterval(intervalId);
          addSnackbar(t('examinations.failure'), 'error');
          setLoadingFile(false);
        }

        getFile({ uuid: res?.uuid }).then((res) => {
          if (res?.status === 1) {
            window.location.href = res?.file;
            clearInterval(intervalId);
            setLoadingFile(false);
          }
        });

        request_counter++;
      }, INTERVAL_TIME);
    });
  };

  return (
    <Button
      className='max-w-fit place-self-end'
      type='button'
      text='Export exam centers stats'
      color='success'
      Icon={ArrowDownTrayIcon}
      loading={loadingFile}
      onClick={() => handle()}
    />
  );
};

export default ExportExamCenterStats;
